var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-main-layout',[_c('bread'),_c('div',{staticClass:"margin-top-30 padding-20"},[_c('div',{staticStyle:{"width":"1000px"},domProps:{"innerHTML":_vm._s(_vm.setting.about)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }